import React from "react";
import SvgIcon from "../SvgIcon";

class TagInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creating: false,
      creatingTitle: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.textInput = null;
    this.setTextInputRef = (element) => {
      this.textInput = element;
    };
    this.focusTextInput = () => {
      if (this.textInput) this.textInput.focus();
    };
    this.addTag = this.addTag.bind(this);
  }

  handleChange({ target: { value } }) {
    this.setState({ creatingTitle: value });
  }

  addTag() {
    if (this.state.creatingTitle.replace(/\s/g, "").length) {
      this.props.pushTag({ title: this.state.creatingTitle });
      this.setState({ creatingTitle: "", creating: true });
      this.focusTextInput();
    }
  }

  render() {
    const { tags = [], pushTag, removeTag } = this.props;
    const limitExceeded = Boolean(tags.length >= 7);
    return (
      <div>
        <ul
          className="tags"
          onClick={() => {
            if (
              !limitExceeded &&
              this.state.creating &&
              this.state.creatingTitle.replace(/\s/g, "").length
            ) {
              pushTag({ title: this.state.creatingTitle });
              this.setState({ creatingTitle: "" });
            } else {
              this.setState({ creating: true });
            }
            this.focusTextInput();
          }}
        >
          {tags.map(({ title }, idx) => (
            <li className="tag" key={idx}>
              <p className="p4">{title}</p>
              <SvgIcon
                src="/img/new-icons/cross.svg"
                alt="delete"
                onClick={() => {
                  removeTag(idx);
                }}
              />
            </li>
          ))}
          {this.state.creating && !limitExceeded && (
            <input
              type="text"
              ref={this.setTextInputRef}
              value={this.state.creatingTitle}
              onChange={this.handleChange}
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.addTag();
                  e.preventDefault();
                }
              }}
            />
          )}

          <p className="st1">Press 'Enter' to add the tag</p>
        </ul>
      </div>
    );
  }
}

export default TagInput;
